// extracted by mini-css-extract-plugin
export default {"paginate":"PersonalisedMenteeEmailersPagination_paginate__Lm-su"};